import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

type LabelWithDescriptionProps = {
    label: string;
    description: string | string[];
    icon?;
};

const Descriptions = ({ description }: { description: string | string[] }) => {
    return (
        <div>
            {typeof description === 'string' ? (
                <p className='mb-0'>{description}</p>
            ) : (
                description.map((_description, idx) => (
                    <p
                        className={idx === description.length - 1 ? 'mb-0' : undefined}
                        key={_description}
                    >
                        {_description}
                    </p>
                ))
            )}
        </div>
    );
};

export function LabelWithDescription(props: LabelWithDescriptionProps) {
    const { label, description, icon } = props;

    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                gap: '10px',
                justifyContent: 'center',
                position: 'relative',
            }}
        >
            <span>{label}</span>
            <Tooltip placement='rightBottom' title={<Descriptions description={description} />}>
                {icon || <QuestionCircleOutlined />}
            </Tooltip>
        </div>
    );
}
